import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function ScottsdaleProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Scottsdale"
      headingExtra="AZ"
      introText="Scottsdale travelers — resort executives, Mayo Clinic physicians, biotech professionals, and Northeast Valley families — have several passport options. Here is how they compare, and why most Scottsdale residents choose a registered State Department courier rather than driving 115 miles to Tucson for an emergency passport agency appointment."
      options={options}
      emergencyDescription="Arizona has only 1 passport agency (Tucson, ~115 miles via I-10, 1.75+ hours). The entire Phoenix metro area — 5+ million people — relies on this single Tucson agency for emergency passport services. Summer temperatures regularly exceed 110°F, making the I-10 desert drive genuinely dangerous with elevated risk of vehicle breakdowns and heat-related emergencies. Monsoon season (July–September) brings flash floods that can close I-10 between Phoenix and Tucson for hours or days. The Tucson agency's limited appointment capacity cannot meet Phoenix metro demand — weeks-long waitlists are standard during peak travel seasons."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}